$(function() {
  /*
		・js-tabsListの子要素にidを指定し、外部ページからハッシュ指定で特定のタブを開くことができます
		・js-tabsListの子要素にclass「is-select」を付与することで、初期表示タブを指定できます
		・ページ内リンクより特定のタブを開き、該当タブの頭に移動するには、js-tabsListの子要素にidを指定し、aタグにてhrefでid指定しclass「js-tabLink」を付与
	*/
  // hash
  if (location.hash) {
    const { hash } = location
    if (
      $(hash)[0] &&
      $('.js-tabsList')
        .children()
        .is(`*${hash}`)
    ) {
      tabInit()
      tabHash(hash)
    } else {
      tabInit()
    }
  } else {
    tabInit()
  }
  // change
  $(document).on('change', '.js-tabsList input[type=radio]', function() {
    const tabListItem = $(this).parent()
    $(tabListItem)
      .siblings()
      .removeClass('is-select')
      .children('input')
      .prop('checked', false)
    $('.js-tabsContents')
      .children()
      .removeClass('is-active')
    $(tabListItem).addClass('is-select')
    const index = $(tabListItem).index()
    $('.js-tabsContents')
      .children()
      .eq(index)
      .addClass('is-active')
  })
  // in page select
  $('.js-tabLink').on('click', function() {
    const href = $(this).attr('href')
    if ($(href)[0]) {
      tabHash(href)
    }
  })
  // tab init
  function tabInit() {
    $('.js-tabsList').each(function() {
      if (
        $(this)
          .children()
          .hasClass('is-select')
      ) {
        const selectedItem = $(this).children('.is-select')
        $(selectedItem)
          .children('input')
          .prop('checked', true)
        const index = $('.js-tabsList')
          .children()
          .index(selectedItem)
        $('.js-tabsContents')
          .children()
          .eq(index)
          .addClass('is-active')
      } else {
        $(this)
          .children()
          .first()
          .addClass('is-select')
          .children('input')
          .prop('checked', true)
        $('.js-tabsContents')
          .children()
          .first()
          .addClass('is-active')
      }
    })
  }
  // hash
  function tabHash(val) {
    const target = $('.js-tabsList').children(val)
    const pos = $('.js-tabsList')
      .children(val)
      .prevAll().length
    $(target)
      .siblings()
      .removeClass('is-select')
      .children('input')
      .prop('checked', false)
    $('.js-tabsContents')
      .children()
      .removeClass('is-active')
    $(target)
      .addClass('is-select')
      .children('input')
      .prop('checked', true)
    $('.js-tabsContents')
      .children()
      .eq(pos)
      .addClass('is-active')
    // scroll
    const position = $('body').offset().top
    $('body,html').scrollTop(position)
  }
})
